import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import './styles/main-styles.css';
import 'react-toastify/dist/ReactToastify.css';
import Navigation from './routers/Navigation';

function App() {
  return (
    <div className="App">
      <Navigation />
      <ToastContainer />
    </div>
  );
}

export default App;
